<template>
  <v-row>

    <v-col cols="12" class="pt-2">
      <v-sheet
        width="100%"
        outlined 
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Habilitar ingreso al público general:</h3>
          </v-col>

          <v-col class="pl-4" cols="12">
            <v-switch 
              v-model="enable_public_access"
              :label="(enable_public_access)?'Deshabilitar ingreso':'Habilitar ingreso'">
            </v-switch>
          </v-col>

          <v-col class="pl-4" cols="12">
            <h4 class="font-weight-regular">Fecha apertura registro:</h4>
          </v-col>

          <v-col cols="6" md="6">
            <v-text-field
              type="date"
              :disabled="!enable_public_access"
              v-model="start_date_public_register"
              outlined
              append-icon="mdi-calendar"
              label="Fecha de inicio"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="6" md="6">
            <v-menu
              ref="menu_h1"
              v-model="menu_h1"
              :disabled="!enable_public_access"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="start_time_public_register"
                  label="Hora de inicio"
                  append-icon="mdi-clock"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  :disabled="!enable_public_access"
                  required
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="start_time_public_register"
                format="24hr"
                @change="menu = false"
              ></v-time-picker>
            </v-menu>
          </v-col>

          <v-col class="pl-4" cols="12">
            <h4 class="font-weight-regular">
              Fecha accedo a la plataforma:
            </h4>
          </v-col>

          <v-col cols="6" md="6">
            <v-text-field
              type="date"
              :disabled="!enable_public_access"
              v-model="start_date_public_access"
              outlined
              append-icon="mdi-calendar"
              label="Fecha de inicio"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="6" md="6">
            <v-menu
              ref="menu_h1"
              v-model="menu_h1"
              :disabled="!enable_public_access"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="start_time_public_access"
                  label="Hora de inicio"
                  append-icon="mdi-clock"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  :disabled="!enable_public_access"
                  required
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="start_time_public_access"
                format="24hr"
                @change="menu = false"
              ></v-time-picker>
            </v-menu>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'editEdition', params: { id: this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_update"
        color="primary"
        @click="updateCallForEntrepreneurs()"
        >
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_error"
      persistent
      max-width="520"
    >
      <v-card>
        <v-card-title class="text-h5">
          Advertencia
        </v-card-title>
        <v-card-text>
          <v-list v-for="error in errors" v-bind:key="error" class="ma-0">
            - {{ error }}
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="dialog_error = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'showEdition',

    data: () => ({
      loading:true,
      loading_update: false,
      dialog_error:false,
      edition:null,
      errors:[],
      
      error:false,

      enable_public_access: false,
      start_date_public_register:null,
      start_time_public_register: null,

      start_date_public_access:null,
      start_time_public_access: null,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },
    },

    watch: {
      date (val) {
        console.log(val)
        this.dateFormatted = this.formatDate(this.date)
      },
    },

    methods:{
      async getEdition(){
        await axios.get('admin/editions/'+this.edition_id).then(response =>{
          this.edition = response.data.edition
          this.enable_public_access =  (this.edition.enable_public_access==1)?true:false

          this.start_date_public_register= this.edition.start_date_public_register
          this.start_time_public_register= this.edition.start_time_public_register

          this.start_date_public_access= this.edition.start_date_public_access
          this.start_time_public_access= this.edition.start_time_public_access

          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      async updateCallForEntrepreneurs(){

        this.loading_update=true
        this.dialog_error = false
        this.errors = []
        // this.validate()

        if(this.enable_public_access=='true'||this.enable_public_access==1){
          this.enable_public_access=='true'
        }

        try {
          await axios.put('admin/editions/'+this.edition_id+'/general-public-access',{
            enable_public_access: this.enable_public_access,
            start_date_public_register: this.start_date_public_register,
            start_time_public_register: this.start_time_public_register,

            start_date_public_access: this.start_date_public_access,
            start_time_public_access: this.start_time_public_access
            }).then(() =>{
              if(this.errors.length===0){
                this.$router.push({ name: 'editEdition', params: { id: this.edition_id } })
              }
            }).catch((error)=>{
              if( error.response.data.errors.length != 0){
                Object.values(error.response.data.errors).forEach(error => {
                  this.errors.push(error[0])
                })
              }

              this.loading=false
              this.dialog_error = true
            })
          } 
        catch (error) {
          //console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
          Object.values(error.response.data.errors).forEach(error => {
            this.errors.push(error[0])
          })
        }

        if(this.errors.length!=0){
          this.loading_update=false
          this.dialog_error=true
        }
      },

      validate(){
        if(this.enable_public_access){
            
          if(!this.start_date_public){
            this.errors.push('Por favor ingrese la fecha de inicio.')
          }

          if(!this.start_time_public_register){
            this.errors.push('Por favor ingrese la hora de inicio.')
          }

          if(!this.start_time_public_access){
            this.errors.push('Por favor ingrese la fecha de finalización.')
          }

          if(!this.finish_time_public){
            this.errors.push('Por favor ingrese la hora de finalización.')
          }

          if(this.start_time_public_access<this.start_date_public){
            this.errors.push('Por favor revise las fechas de inicio y fin.')
          }

          if(this.start_time_public_access==this.start_date_public){
            if(this.finish_time_public<=this.start_time_public_register){
              this.errors.push('Por favor revise la hora de inicio y fin.')
            }
          }
        }
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id;
      this.getEdition()
    },
  }
</script>